import i18n from 'i18next';
import * as yup from 'yup';

yup.setLocale({
  string: {
    min: ({ min, label }) =>
      i18n.t('checkout.forms.validations.min', { label, min }),
    max: ({ max, label }) =>
      i18n.t('checkout.forms.validations.max', { label, max }),
  },
});

const fields = {
  name: {
    form: {
      name: 'name',
      label: i18n.t('checkout.forms.fields.name'),
      placeholder: i18n.t('checkout.forms.fields.name'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.name'))
      .max(50)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  holder: {
    form: {
      name: 'name',
      label: i18n.t('checkout.forms.fields.holder'),
      placeholder: i18n.t('checkout.forms.fields.holder'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.holder'))
      .max(50)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  email: {
    form: {
      name: 'email',
      label: i18n.t('checkout.forms.fields.email'),
      placeholder: i18n.t('checkout.forms.fields.email'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.email'))
      .max(50)
      .email(() => i18n.t('checkout.forms.validations.email'))
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        i18n.t('checkout.forms.validations.email')
      )
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  phone: {
    form: {
      name: 'phone',
      label: i18n.t('checkout.forms.fields.phone'),
      placeholder: i18n.t('checkout.forms.fields.phone'),
    },
    validation: yup
      .string()
      .min(8)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  password: {
    form: {
      name: 'password',
      label: i18n.t('checkout.forms.fields.password'),
      placeholder: i18n.t('checkout.forms.fields.password'),
    },
    validation: yup
      .string()
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  lastName: {
    form: {
      name: 'lastName',
      label: i18n.t('checkout.forms.fields.lastName'),
      placeholder: i18n.t('checkout.forms.fields.lastName'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.lastName'))
      .max(50)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  creditCard: {
    form: {
      name: 'creditCard',
      label: i18n.t('checkout.forms.fields.creditCard'),
      placeholder: i18n.t('checkout.forms.fields.creditCard'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.creditCard'))
      .min(15)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  validity: {
    form: {
      name: 'validity',
      label: i18n.t('checkout.forms.fields.validity'),
      placeholder: i18n.t('checkout.forms.fields.validity'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.validity'))
      .min(4)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  zipCode: {
    form: {
      name: 'zipCode',
      label: i18n.t('checkout.forms.fields.zipCode'),
      placeholder: i18n.t('checkout.forms.fields.zipCode'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.zipCode'))
      .min(5)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  state: {
    form: {
      name: 'state',
      label: i18n.t('checkout.forms.fields.state'),
      placeholder: i18n.t('checkout.forms.fields.state'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.state'))
      .min(5)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  city: {
    form: {
      name: 'city',
      label: i18n.t('checkout.forms.fields.city'),
      placeholder: i18n.t('checkout.forms.fields.city'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.city'))
      .min(5)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
  code: {
    form: {
      name: 'code',
      label: i18n.t('checkout.forms.fields.coupon'),
      placeholder: i18n.t('checkout.forms.fields.coupon'),
    },
    validation: yup
      .string()
      .label(i18n.t('checkout.forms.fields.coupon'))
      .max(20)
      .required(({ label }) =>
        i18n.t('checkout.forms.validations.required', { label }),
      ),
  },
};

const getFields = () => {
  return {
    name: {
      form: {
        name: 'name',
        label: i18n.t('checkout.forms.fields.name'),
        placeholder: i18n.t('checkout.forms.fields.name'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.name'))
        .max(50)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    holder: {
      form: {
        name: 'name',
        label: i18n.t('checkout.forms.fields.holder'),
        placeholder: i18n.t('checkout.forms.fields.holder'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.holder'))
        .max(50)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    cardNumber: {
      form: {
        name: 'cardNumber',
        label: i18n.t('checkout.payment.cardNumber'),
        placeholder: i18n.t('checkout.payment.cardNumber'),
      },
      validation: yup.string(),
    },
    cvv: {
      form: {
        name: 'cvv',
        label: i18n.t('checkout.payment.cvv'),
        placeholder: i18n.t('checkout.payment.cvv'),
      },
      validation: yup.string(),
    },
    email: {
      form: {
        name: 'email',
        label: i18n.t('checkout.forms.fields.email'),
        placeholder: i18n.t('checkout.forms.fields.email'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.email'))
        .max(50)
        .email(() => i18n.t('checkout.forms.validations.email'))
        .matches(
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          i18n.t('checkout.forms.validations.email')
        )
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    phone: {
      form: {
        name: 'phone',
        label: i18n.t('checkout.forms.fields.phone'),
        placeholder: i18n.t('checkout.forms.fields.phone'),
      },
      validation: yup
        .string()
        .min(8)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    password: {
      form: {
        name: 'password',
        label: i18n.t('checkout.forms.fields.password'),
        placeholder: i18n.t('checkout.forms.fields.password'),
      },
      validation: yup
        .string()
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    lastName: {
      form: {
        name: 'lastName',
        label: i18n.t('checkout.forms.fields.lastName'),
        placeholder: i18n.t('checkout.forms.fields.lastName'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.lastName'))
        .max(50)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    creditCard: {
      form: {
        name: 'creditCard',
        label: i18n.t('checkout.forms.fields.creditCard'),
        placeholder: i18n.t('checkout.forms.fields.creditCard'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.creditCard'))
        .min(15)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    validity: {
      form: {
        name: 'validity',
        label: i18n.t('checkout.forms.fields.validity'),
        placeholder: i18n.t('checkout.forms.fields.validity'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.validity'))
        .min(4)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    zipCode: {
      form: {
        name: 'zipCode',
        label: i18n.t('checkout.forms.fields.zipCode'),
        placeholder: i18n.t('checkout.forms.fields.zipCode'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.zipCode'))
        .min(5)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    state: {
      form: {
        name: 'state',
        label: i18n.t('checkout.forms.fields.state'),
        placeholder: i18n.t('checkout.forms.fields.state'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.state'))
        .min(2)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    city: {
      form: {
        name: 'city',
        label: i18n.t('checkout.forms.fields.city'),
        placeholder: i18n.t('checkout.forms.fields.city'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.city'))
        .min(2)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
    code: {
      form: {
        name: 'code',
        label: i18n.t('checkout.forms.fields.coupon'),
        placeholder: i18n.t('checkout.forms.fields.coupon'),
      },
      validation: yup
        .string()
        .label(i18n.t('checkout.forms.fields.coupon'))
        .max(20)
        .required(({ label }) =>
          i18n.t('checkout.forms.validations.required', { label }),
        ),
    },
  };
};

const getYupObject = () => {
  yup.setLocale({
    string: {
      min: ({ min, label }) =>
        i18n.t('checkout.forms.validations.min', { label, min }),
      max: ({ max, label }) =>
        i18n.t('checkout.forms.validations.max', { label, max }),
    },
  });

  return yup;
};

export { yup, fields, getFields, getYupObject };
